import classNames from 'classnames';

import {gettext, interpolate} from 'topmeteo/utils/i18n';

import Columns from './Columns';
import FavouriteIcon from './FavouriteIcon';

const RemoveFavouriteLabel = gettext('Remove %s as favorite');
const AddFavouriteLabel = gettext('Add %s as favorite');

const getFavouriteMessage = (title, isFavourite) => (
    interpolate(isFavourite ? RemoveFavouriteLabel : AddFavouriteLabel, [title], false)
);

const Product = ({id, identifier, title, columns, current, isFavourite}) => (
    <tr id={`product-${id}`} className={classNames({current})} data-identifier={identifier}>
        <th title={getFavouriteMessage(title, isFavourite)}>
            <FavouriteIcon id={id} isFavourite={isFavourite} />
            <span className="product-title">{title}</span>
        </th>
        <Columns productID={id} columns={columns} />
    </tr>
);

export default Product;
